import script from "./MainBranch.vue?vue&type=script&setup=true&lang=js"
export * from "./MainBranch.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__